import { gql } from '@apollo/client';

export const UPDATE_CLASSE_ONG = gql`
  mutation UpdateClasseOng($id: ID!, $data: ClasseInput!) {
    updateClasse(id: $id, data: $data) {
      data {
        id
        attributes {
          ong
          percentDedicatedToOng
        }
      }
    }
  }
`;
